import React from 'react';

const CodeDisplay = ({ items, title, emptyMessage = 'No codes generated yet.' }) => {
  if (!items || items.length === 0) {
    return (
      <div className="empty-state">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="code-display">
      {title && <h3 className="code-display-title">{title}</h3>}
      <div className="code-grid">
        {items.map((item, index) => {
          const id = item.tankId || item.id || index;
          const base64 = item.qrCodeBase64 || item.barcodeBase64 || item.code || '';
          
          if (!base64) return null;
          
          const imgSrc = `data:image/png;base64,${base64}`;
          
          return (
            <div className="code-item" key={index}>
              <img src={imgSrc} alt={`Code ${id}`} />
              <span className="code-label">ID: {id}</span>
              {item.text && <span className="code-text">{item.text}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CodeDisplay;